:host {
  @apply inline-block;
}

::slotted(img) {
  @apply w-full h-full object-cover;
}

::slotted(picture) {
  @apply flex w-full h-auto overflow-hidden;
}

::slotted(a[slot^=image-]) {
  @apply flex w-full h-auto overflow-hidden;
}

div[gallery-type="two"] {
  ::slotted(img[slot=image-one]),
  ::slotted(picture[slot=image-one]),
  ::slotted(a[slot=image-one]) {
    @apply rounded-tl-[5px] rounded-tr-[5px] md:rounded-tr-none md:rounded-bl-[5px];
  }

  ::slotted(img[slot=image-two]),
  ::slotted(picture[slot=image-two]),
  ::slotted(a[slot=image-two]) {
    @apply rounded-br-[5px] rounded-bl-[5px] md:rounded-bl-none md:rounded-tr-[5px];
  }
}

div[gallery-type="three-left"] {
  ::slotted(img[slot=image-one]),
  ::slotted(picture[slot=image-one]),
  ::slotted(a[slot=image-one]) {
    @apply rounded-tl-[5px] rounded-tr-[5px] md:rounded-tr-none md:rounded-bl-[5px];
  }

  ::slotted(img[slot=image-two]),
  ::slotted(picture[slot=image-two]),
  ::slotted(a[slot=image-two]) {
    @apply md:rounded-tr-[5px];
  }

  ::slotted(img[slot=image-three]),
  ::slotted(picture[slot=image-three]),
  ::slotted(a[slot=image-three]) {
    @apply rounded-br-[5px] rounded-bl-[5px] md:rounded-bl-none;
  }
}

div[gallery-type="three-right"] {
  ::slotted(img[slot=image-one]),
  ::slotted(picture[slot=image-one]),
  ::slotted(a[slot=image-one]) {
    @apply rounded-tl-[5px] rounded-tr-[5px] md:rounded-tr-none;
  }

  ::slotted(img[slot=image-two]),
  ::slotted(picture[slot=image-two]),
  ::slotted(a[slot=image-two]) {
    @apply md:rounded-tr-[5px] md:rounded-br-[5px];
  }

  ::slotted(img[slot=image-three]),
  ::slotted(picture[slot=image-three]),
  ::slotted(a[slot=image-three]) {
    @apply rounded-bl-[5px] rounded-br-[5px] md:rounded-br-none;
  }
}

div[gallery-type="four"] {
  ::slotted(img[slot=image-one]),
  ::slotted(picture[slot=image-one]),
  ::slotted(a[slot=image-one]) {
    @apply rounded-tl-[5px] rounded-tr-[5px] md:rounded-tr-none;
  }

  ::slotted(img[slot=image-two]),
  ::slotted(picture[slot=image-two]),
  ::slotted(a[slot=image-two]) {
    @apply md:rounded-tr-[5px];
  }

  ::slotted(img[slot=image-three]),
  ::slotted(picture[slot=image-three]),
  ::slotted(a[slot=image-three]) {
    @apply md:rounded-bl-[5px];
  }

  ::slotted(img[slot=image-four]),
  ::slotted(picture[slot=image-four]),
  ::slotted(a[slot=image-four]) {
    @apply rounded-br-[5px] rounded-bl-[5px] md:rounded-bl-none;
  }
}

::slotted(a[slot=image-one]),
::slotted(a[slot=image-two]),
::slotted(a[slot=image-three]),
::slotted(a[slot=image-four]) {
  @apply block overflow-hidden;
}

// ::slotted([slot=downloads]:first-of-type) {
//   @apply md:py-2 md:flex-1;
// }

// ::slotted([slot=downloads]:not(:first-of-type)) {
//   @apply mt-3 pt-3 border-x-0 border-y-0 border-t border-solid border-grey-lighter md:mt-0 md:py-2 md:border-0 md:flex-1;
// }
